import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from './shared/shared.module';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
//REDUX
import {StoreModule} from '@ngrx/store'
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {appReducers} from './app.reducer';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
//environmet
import {environment} from '../environments/environment';
//httpclient
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';


//components
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {TopbarComponent} from './components/topbar/topbar.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FullScreenComponent} from './theme/components/fullscreen/fullscreen.component';
import {LoginComponent} from './pages/login/login.component';
import {LoginConvocatoriaComponent} from './pages/login-convocatoria/login-convocatoria.component';
//Firebase
/* import {AngularFirestoreModule} from '@angular/fire/firestore';
import {AngularFireModule} from '@angular/fire';
import {AngularFireAuthModule} from '@angular/fire/auth'; */
import {HomeComponent} from './pages/home/home.component';
import {CommonModule} from '@angular/common';
import { TokenInterceptorService } from './interceptors/token-interceptor.service';


const COMPONENTS = [
	AppComponent,
	SidebarComponent,
	TopbarComponent,
	DashboardComponent,
	LoginComponent,
	LoginConvocatoriaComponent,
	HomeComponent,
	FullScreenComponent
];

const MODULES = [
	CommonModule, // puede ser llamado en shared module
	BrowserModule, // puede ser puesto en un core module
	AppRoutingModule,
	//HttpClientModule, // puede ser llamado en shared module
	BrowserAnimationsModule, // puede ser puesto en un core module
	//ReactiveFormsModule,  // doble llamado (tambien->sharedModule)
	/* AngularFireAuthModule, // puede ser puesto en un core module */
	/* AngularFireModule.initializeApp(environment.firebaseConfig), // puede ser puesto en un core module */
	/* AngularFirestoreModule, // puede ser puesto en un core module */
	SharedModule,
];

@NgModule({
  declarations: [
	COMPONENTS
  ],
  imports: [
    MODULES,
    StoreModule.forRoot(appReducers), // puede ser puesto en core module
    StoreDevtoolsModule.instrument({
      maxAge:25,
      logOnly:environment.production,
    }) // puede ser puesto en core module
  ],
  providers: [
	{
		provide: HTTP_INTERCEPTORS,
		useClass: TokenInterceptorService,
		multi: true,
	}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
